<!--
 * @Description: 继教页
 * @Author: tanglitong
 * @CreationDate: 2022/7/15 11:06
-->
<!--学习中心cme页面-->
<template>
  <div class="nup_main">
    <!--项目导航-->
    <div class="nupm_projectNav f_l">
      <div class="nupmpn_title">项目导航</div>
      <!--<div v-for="(item,index) in disciplineCategoryList" class="nupmpn_main">-->
      <!--	<div class="nupmpnm"><a href="javascript:" @click="addSubProjectParam(item.id)">{{ item.name }}</a>-->
      <!--		<div-->
      <!--			:class="{ 'sub_nav_child_bottom' : index>=disciplineCategoryList.length/2 ,'sub_nav_child_top':index<disciplineCategoryList.length/2}"-->
      <!--			class="nupmpnm_disk">-->
      <!--			<a v-for="childItem in item.childs" href="javascript:"-->
      <!--				@click="addSubProjectParam(childItem.id)">{{ childItem.name }}</a>-->
      <!--		</div>-->
      <!--	</div>-->
      <!--</div>-->
      <el-menu
        ref="cmp_menu"
        :default-active="subId"
        class="cmp_menu"
        collapse-transition
        unique-opened
        @close="handleClick"
        @open="handleClick"
      >
        <el-submenu
          :class="['all_subject',{ 'submenu_selected': subId === '' }]"
          index=""
          @click="handleClick('')"
        >
          <template slot="title">
            <span>全部学科</span>
          </template>
        </el-submenu>
        <el-submenu
          v-for="item in disciplineCategoryList"
          :key="item.id"
          :class="{ 'submenu_selected': subId === String(item.id) }"
          :index="String(item.id)"
        >
          <template slot="title">
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item
            v-for="itemc in item.childs"
            :key="itemc.id"
            :index="String(itemc.id)"
            @click="handleClick(String(itemc.id))"
          >
            <span slot="title">{{ itemc.name }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <!--推荐项目/我的项目-->
    <div v-loading="loading" class="nupm_right f_r" element-loading-text="拼命加载中">
      <div class="nupmr_title">
        <!--<a :class="{ new_myCourse_sel: tabCode==0 }" href="javascript:"-->
        <!--	@click="switchProjectType(false,0)">{{ listName }}</a>-->
        <!--<a :class="{ new_myCourse_sel: tabCode==1  }" href="javascript:" @click="switchProjectType(true,1)">我的项目</a>-->
        <!--<a :class="{ new_myCourse_sel: tabCode==2  }" href="javascript:" @click="switchProjectType(false,2)">十堰专家讲座</a>-->
        <a
          :class="{ new_myCourse_sel: switchMyProject === false && menuType === 'all' }"
          href="javascript:"
          @click="switchProjectType(false, 'all')"
        >所有项目</a>
        <a
          :class="{ new_myCourse_sel: switchMyProject === false && menuType ==='recommend' }"
          href="javascript:"
          @click="switchProjectType(false, 'recommend')"
        >推荐项目</a>
        <a
          :class="{ new_myCourse_sel: switchMyProject === true }"
          href="javascript:"
          @click="switchProjectType(true)"
        >我的项目</a>
        <a
          :class="{ new_myCourse_sel: switchMyProject === false && menuType ==='expert' }"
          href="javascript:"
          @click="switchProjectType(false, 'expert')"
        >十堰专家讲座</a>
      </div>
      <div class="nupmr_main">
        <div v-show="tabCode!=2" class="nupmrm_case">
          <p class="npm_case1">
            <span style="color:red;font-weight:normal;">{{ currentTraining.trainingNotice }}</span>
          </p>
          <p id="new_projState" class="npm_case1">
            <span>项目状态：</span>
            <label :class="{ 'new_radio_sel' : projState==''   }"><input v-model="projState" name="projState"
              type="radio"
              value="">全部</label>
            <label :class="{ 'new_radio_sel' : projState=='4'  }"><input v-model="projState" name="projState"
              type="radio"
              value="4"/>未学习</label>
            <label :class="{ 'new_radio_sel' : projState=='1'  }"><input v-model="projState" name="projState"
              type="radio"
              value="1"/>学习中</label>
            <label :class="{ 'new_radio_sel' : projState=='2'  }"><input v-model="projState" name="projState"
              type="radio"
              value="2"/>已学完</label>
            <label :class="{ 'new_radio_sel' : projState=='3'  }"><input v-model="projState" name="projState"
              type="radio"
              value="3"/>已申请</label>
          </p>
          <p class="npm_case2">
            <!--<select v-model="projType" >
              <option value="">项目类型</option>
              <option :value="item.id" v-for="(item, index) in projTypeList">{{item.name}}</option>
            </select>
            <select v-model="creType" >
              <option value="">学分类别</option>
              <option :value="item.id" v-for="(item, index) in creTypeList">{{item.name}}</option>
            </select>
            <select v-model="creValue">
              <option value="">学分</option>
              <option value="5">5</option>
              <option value="4">4</option>
              <option value="3">3</option>
              <option value="6">其他</option>
            </select>-->
            <span>项目名称：</span>
            <input v-model="projParam" placeholder="项目名称/项目负责人" style="width: 300px;" type="text"/>
            <input type="button" value="搜索" @click="pagination.currentPage = 1; groomSearch()"/>
            <input type="button" value="重置" @click="resetParam"/>
          </p>
        </div>
        <div class="nupmrm_content">
          <!--推荐项目、我的项目-->
          <div v-for="(item,index) in projList" v-if="tabCode!=2" class="npc_box">
            <div class="npcb_pic">
              <router-link
                :to="{ path: '/usercenter/projectDtail', query: { trainingId: currentTraining.id, projectId:item.projId}}"
                target="_blank">
                <img :src="item.iamge"/>
              </router-link>
            </div>
            <div class="npcb_txt">
              <router-link :class="{'projectName_top':item.setTop==1}"
                :title="item.projectName"
                :to="{ path: '/usercenter/projectDtail', query: { trainingId: currentTraining.id, projectId:item.projId,setTop:item.setTop}}"
                target="_blank">
                <span class="npcbt_title">{{ item.projectName }}</span>
                <span
                  class="npcbt_info">项目负责人：{{ item.nickName ? item.nickName : '--'
                  }}　　 项目类别：{{ item.proCategoryName ? item.proCategoryName : '--'
                  }}　　学分类别：{{ item.creCategoryName ? item.creCategoryName : '--'
                  }}　　学分：{{ item.creditSetting ? item.creditSetting : '--' }}</span>
              </router-link>
            </div>
            <div class="npcb_status">
              <span v-if="item.projState==0 || item.projState==null">【未学习】</span>
              <span v-if="item.projState==1">【学习中】</span>
              <span v-if="item.projState==2">【已学完】<a href="javascript:"
                @click="applyScore(currentTraining.id,item.projId,item.creditCateggory,item.creditSetting)">[申请学分]</a></span>
              <span v-if="item.projState==3">
                【已申请】<a href="javascript:" @click="cancelApplyScore(currentTraining.id,item.projId)">[取消申请]</a>
              </span>
              <span v-if="item.projState==4">【已授予】</span>
              
              <div v-if="item.isOwn == 1">
                <a v-if="switchMyProject" href="javascript:"
                  @click="removeFromMyProject( item.proStateId )">[×删除项目]</a>
                <span v-else>【已加入我的项目】</span>
              </div>
              <a v-else href="javascript:"
                @click="addToMyProject(currentTraining.id,item.projId)">[+添加到我的项目中]</a>
            </div>
          </div>
          <!--十堰专家讲座-->
          <div v-for="(item,index) in projListzj" v-if="tabCode==2 " class="npc_box">
            <div class="npcb_pic">
              <router-link
                :to="{ path: '/usercenter/projectDtail', query: { trainingId: currentTraining.id, projectId:item.projId,setTop:1}}"
                target="_blank">
                <img :src="item.iamge"/>
              </router-link>
            </div>
            <div class="npcb_txt">
              <router-link :class="{'projectName_top':item.setTop==1}"
                :title="item.projectName"
                :to="{ path: '/usercenter/projectDtail', query: { trainingId: currentTraining.id, projectId:item.projId,setTop:1}}"
                target="_blank">
                <span class="npcbt_title">{{ item.projectName }}</span>
                <span
                  class="npcbt_info">项目负责人：{{ item.nickName ? item.nickName : '--'
                  }}　　 项目类别：{{ item.proCategoryName ? item.proCategoryName : '--'
                  }}　　学分类别：{{ item.creCategoryName ? item.creCategoryName : '--'
                  }}　　学分：{{ item.creditSetting ? item.creditSetting : '--' }}</span>
              </router-link>
            </div>
            <div class="npcb_status">
              <span v-if="item.projState==0 || item.projState==null">【未学习】</span>
              <span v-if="item.projState==1">【学习中】</span>
              <span v-if="item.projState==2">【已学完】<a href="javascript:"
                @click="applyScore(currentTraining.id,item.projId,item.creditCateggory,item.creditSetting)">[申请学分]</a></span>
              <span v-if="item.projState==3">
                【已申请】<a href="javascript:" @click="cancelApplyScore(currentTraining.id,item.projId)">[取消申请]</a>
              </span>
              <span v-if="item.projState==4">【已授予】</span>
              
              <div v-if="item.isOwn == 1">
                <a v-if="switchMyProject" href="javascript:"
                  @click="removeFromMyProject( item.proStateId )">[×删除项目]</a>
                <span v-else>【已加入我的项目】</span>
              </div>
              <a v-else href="javascript:"
                @click="addToMyProject(currentTraining.id,item.projId)">[+添加到我的项目中]</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addToMyProject,
  applyCredit,
  calcelApplyCredit,
  getCreTypeList,
  getProjTypeList,
  listDisciplineCategoryAndChild,
  listStudentProjInfoAndStatus,
  listStudentProjInfoAndStatusForExpert,
  removeFromMyProject
} from '../api/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    currentTraining: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tabCode: 0,
      examVisible: false,
      loading: false,
      projList: null,
      projListzj: null,
      disciplineCategoryList: null,
      disciplineCategoryViewMoreFlag: false,
      disciplineCategoryViewMoreText: '查看更多>>',
      switchMyProject: false,
      menuType: false,
      pagination: {
        currentPage: 1,
        pageSize: 1000,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },
      projTypeList: [],
      creTypeList: [],
      projType: '',
      creType: '',
      projParam: '',
      projState: '',
      creValue: '',
      subId: '',
      subClass: '',
      listName: '推荐项目'
      
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted() {
    // this.switchProjectType(this.switchMyProject, 0)
    this.switchProjectType(this.switchMyProject, 'all')
    listDisciplineCategoryAndChild().then((response) => {//获得所有学科和二级学科
      let disciplineCategoryAndChildList = response.data.data.list
      this.disciplineCategoryList = disciplineCategoryAndChildList
    })
    getProjTypeList({type: 1}).then((response) => {
      this.projTypeList = response.data.data
    })
    getCreTypeList({type: 2}).then((response) => {
      this.creTypeList = response.data.data
    })
  },
  watch: {
    currentTraining: function (newValue, oldValue) {
      this.resetParam()
    },
    projList: function (newValue, oldValue) {
      if (newValue != null) {
        this.projListzj = newValue.filter(val => val.setTop == 1)
      }
    }
  },
  methods: {
    groomSearch() {//搜索
      this.loading = true
      const params = {//获得项目和课程状态
        userId: this.userInfo.id,
        trainingId: this.currentTraining.id,
        projType: this.projType,
        projState: this.projState,
        creType: this.creType,
        creValue: this.creValue,
        projParam: this.projParam,
        myProj: this.switchMyProject,
        subId: this.subId,
        recommend: this.menuType === 'recommend' || this.menuType === 'expert', //是否推荐
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }
      if (this.menuType === 'expert') {
        listStudentProjInfoAndStatusForExpert(params).then(res => {
          this.loading = false
          const {status, data} = res
          if (status !== 200) return
          this.projList = data.list
          this.pagination.total = data.total
        }).catch(() => {
          this.loading = false
        })
      } else {
        listStudentProjInfoAndStatus(params).then((response) => {
          this.projList = response.data.data.list
          this.pagination.total = response.data.data.total
          this.loading = false
          if (this.menuType === 'recommend') {
            this.projList.sort(function (a, b) {
              if (a.sort == b.sort) {
                return b.createTime - a.createTime
              } else {
                return b.sort - a.sort
              }
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }
    },
    viewMore() {
      this.disciplineCategoryViewMoreFlag = !this.disciplineCategoryViewMoreFlag
      if (this.disciplineCategoryViewMoreFlag) {
        this.disciplineCategoryViewMoreText = '收起更多>>'
      } else {
        this.disciplineCategoryViewMoreText = '查看更多>>'
      }
    },
    // switchProjectType(switchMyProject, tabCode) {
    switchProjectType(switchMyProject, menuType) {
      // this.tabCode = tabCode
      this.loading = true
      this.switchMyProject = switchMyProject
      this.menuType = menuType
      setTimeout(() => {
        const params = {
          userId: this.userInfo.id,
          trainingId: this.currentTraining.id,
          projType: this.projType,
          projState: this.projState,
          creType: this.creType,
          creValue: this.creValue,
          projParam: this.projParam,
          myProj: switchMyProject,
          subId: this.subId,
          recommend: this.menuType === 'recommend', //是否推荐
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
        if (this.menuType === 'expert') {
          listStudentProjInfoAndStatusForExpert(params).then(res => {
            this.loading = false
            const {status, data} = res
            if (status !== 200) return
            this.projList = data.list
            this.pagination.total = data.total
          }).catch(() => {
            this.loading = false
          })
        } else {
          listStudentProjInfoAndStatus(params).then((response) => {
            this.projList = response.data.data.list
            this.pagination.total = response.data.data.total
            this.loading = false
            // if (tabCode == 0) {
            if (menuType === 'recommend') {
              this.projList.sort(function (a, b) {
                if (a.sort == b.sort) {
                  return b.createTime - a.createTime
                } else {
                  return b.sort - a.sort
                }
              })
            }
          }).catch(() => {
            this.loading = false
          })
        }
      }, 300)
    },
    applyScore(trainingId, projectId, creditCateggory, creditSetting) {
      if (this.readOnly == true) {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      } else {
        if (!creditCateggory || creditCateggory == '' || creditCateggory == null || creditCateggory == '0' ||
          !creditSetting || creditSetting == '' || creditSetting == null || creditSetting == '0') {
          this.$alert('该项目在您所在地区尚未开展，您暂不能申请学分！', '提示', {
            confirmButtonText: '确定'
          })
        } else {
          this.$confirm('是否确定申请此项目学分?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            applyCredit({
              trainingId: trainingId,
              projectId: projectId,
              userId: this.userInfo.id
            }).then((response) => {
              this.loading = false
              if (response.data.status == 1) {
                this.$alert(response.data.info, '提示', {
                  confirmButtonText: '确定',
                  type: 'success',
                  callback: action => {
                    this.switchProjectType(this.switchMyProject, this.tabCode)
                    
                  }
                })
              } else {
                if (response.data.info == '人员信息在本省学分管理平台不存在，请下载继教通APP进行注册'
                  || response.data.info == '人员信息与本省学分管理平台不一致，请核实修改') {
                  this.$alert('<div style="text-align:center;font-size:13px;">' +
                    '<p style="padding-bottom:25px;">' + response.data.info + '</p>' +
                    '<img src="https://source.yiboshi.com/public/img/%E7%BB%A7%E6%95%99%E9%80%9AAPP%E4%B8%8B%E8%BD%BD.gif">' +
                    '<p style="color:#9A9A9A;font-size:12px;">手机扫一扫下载继教通客户端</p>', '提示', {
                    dangerouslyUseHTMLString: true
                  })
                } else {
                  this.$alert(response.data.info, '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {
                    }
                  })
                }
              }
            })
          }).catch(() => {
            /*this.$message({
             type: 'warning',
             message: '申请失败'
             });*/
          })
        }
      }
    },
    cancelApplyScore(trainingId, projectId) {
      if (this.readOnly == true) {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      } else {
        this.$confirm('确认要取消申请学分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          calcelApplyCredit({
            trainingId: trainingId,
            projectId: projectId,
            userId: this.userInfo.id
          }).then((response) => {
            if (response.data.status == 1) {
              this.$alert(response.data.info, '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  this.switchProjectType(this.switchMyProject, this.tabCode)
                }
              })
            } else {
              this.$alert(response.data.info, '提示', {
                confirmButtonText: '确定',
                type: 'error'
              })
            }
          })
        }).catch(() => {
          /*this.$message({
           type: 'warning',
           message: '取消申请失败'
           });*/
        })
      }
    },
    addToMyProject(trainingId, projId) {
      addToMyProject({
        trainingId: trainingId,
        projectId: projId,
        userId: this.userInfo.id
      }).then((response) => {
        if (response.data.status == 200) {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              this.switchProjectType(this.switchMyProject, this.tabCode)
            }
          })
        } else {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'error'
          })
        }
      })
    },
    removeFromMyProject(proStateId) {
      removeFromMyProject({
        proStateId: proStateId
      }).then((response) => {
        if (response.data.status == 200) {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              this.switchProjectType(this.switchMyProject, this.tabCode)
            }
          })
        } else {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'error'
          })
        }
      })
    },
    addSubProjectParam(id) {
      this.subId = id
      this.subClass = id
      /*切换成所有项目*/
      this.listName = '所有项目'
      this.switchProjectType(this.switchMyProject, this.tabCode)
    },
    resetParam() {
      // this.subId = ''
      this.projType = ''
      this.creType = ''
      this.projParam = ''
      this.projState = ''
      this.creValue = ''
      // this.subId = ''
      // this.subClass = ''
      // this.tabCode = 0
      // this.switchProjectType(this.switchMyProject, this.tabCode)
      this.switchProjectType(this.switchMyProject, this.menuType)
      // this.listName = '推荐项目'
    },
    /**
     * @description: 导航切换
     */
    handleClick(id) {
      this.subId = id
      this.switchProjectType(this.switchMyProject, 'all')
    },
    /**
     * @description: 每页条数
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.groomSearch()
    },
    /**
     * @description: 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.groomSearch()
    }
  }
}
</script>
<style lang="scss">
.nup_main {
  .cmp_menu {
    .el-submenu {
      border: 1px #D8D8D8 solid;
      border-top: 0;
      border-right: 0;
      
      .el-submenu__title {
        height: 35px;
        line-height: 35px;
        
        .el-submenu__icon-arrow {
          font-size: 14px;
        }
        
        .el-icon-arrow-down:before {
          content: "\E791";
        }
        
        &::after {
          content: " ";
          display: inline-block;
          width: 4px;
          height: 0;
          background-color: #38BCD5;
          position: absolute;
          left: 0;
          top: 0;
          transition: all .3s;
        }
      }
      
      .el-menu {
        .el-menu-item {
          height: 35px;
          line-height: 35px;
          
          &::after {
            content: " ";
            display: inline-block;
            width: 4px;
            height: 0;
            background-color: #38BCD5;
            position: absolute;
            left: 0;
            top: 0;
            transition: all .3s;
          }
          
          &.is-active {
            &::after {
              content: " ";
              display: inline-block;
              width: 4px;
              height: 35px;
              background-color: #38BCD5;
              position: absolute;
              left: 0;
              top: 0;
              transition: all .3s;
            }
          }
        }
      }
      
      &.is-opened > .el-submenu__title .el-submenu__icon-arrow {
        transform: rotateZ(90deg);
      }
      
      &.submenu_selected {
        .el-submenu__title {
          color: #38BCD5;
          
          &::after {
            content: " ";
            display: inline-block;
            width: 4px;
            height: 35px;
            background-color: #38BCD5;
            position: absolute;
            left: 0;
            top: 0;
            transition: all .3s;
          }
        }
      }
      
      &.all_subject {
        .el-submenu__icon-arrow {
          display: none;
        }
      }
    }
  }
  
  .project_pagination {
    text-align: center;
    padding: 10px 0;
    
    .el-pagination__jump {
      margin-left: 0;
    }
  }
}
</style>
<style scoped>
/*.sub_nav_child_top {*/
/*	top: -1px;*/
/*}*/

/*.sub_nav_child_bottom {*/
/*	bottom: -1px*/
/*}*/

/*.npm_notice {*/
/*	margin-bottom: 12px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/CmePage.vue